<template>
  <section class="shop-content">
    <!-- <download></download> -->
    <van-swipe :autoplay="3000" indicator-color="white">
      <van-swipe-item  @click="goto(index)" v-for="(image, index) in images" :key="index" >
        <img style="width : 100%;float: left" :src="image.image" alt="">
      </van-swipe-item>
    </van-swipe>
    <div v-if="step" class="step">
      <div class="tu" v-for="(item,index) in stepList" :key="index" >
        <img :src="item.image" alt="" @click="step_change(index)">
        <p>{{item.text}}</p>
      </div>
    </div>
    <div v-if="extension" class="extension">
      <img src="@/assets/picture/extension1.jpg" @click="selfrun" alt="">
      <img src="@/assets/picture/extension2.jpg" @click="recovery" alt="">
    </div>
    <div class="look" @click="service">
      <img src="@/assets/picture/4.png" alt="">
    </div>
    <!-- 每日上新 -->
    <div class="new">
      <div class="new-cen" >
        <img @click="toTopicDetail(newList.activityId)" src="@/assets/picture/5.1.png" alt="">
        <div class="new_shop" style="font-size: .28rem;" v-if="newList.commodityNewNumber != 0">NEW {{newList.commodityNewNumber}}款</div>
        <img v-if="leakList" @click="toTopicDetail(leakList.activityId)" :src="leakList.activityPicture" alt="">
        <div v-if="leakList" class="leak_shop" style="top: 12%;font-weight: bolder;">{{leakList.mainTitle}}</div>
        <div v-if="leakList"  class="leak_shop" style="font-size:.28rem">{{leakList.subtitle}}</div>
        <img v-if="zoneList" @click="toTopicDetail(zoneList.activityId)" :src="zoneList.activityPicture" alt="">
        <div v-if="zoneList" class="zone_shop" style="font-weight:bolder">{{zoneList.mainTitle}}</div>
        <div v-if="zoneList" class="zone_shop" style="top:91%;font-size:.28rem">{{zoneList.subtitle}}</div>
      </div>
    </div>
    <div class="brand">
      <div class="tit" style="position : relative">
        <p style="position: absolute; ">胖虎大牌</p>
        <span style="position: absolute;left: 23%;">PONHU BRAND</span></div>
      <div class="brand-shop" >
        <img v-for="(item,index) in brandList" :key="index" :src="item.activityPicture" @click="toTopicDetail(item.activityId)" alt="">
      </div>
    </div>
    <div class="brand">
      <div class="tit">胖虎推荐<span>PONHU RECOMMAND</span></div>
      <div class="recommend" v-for="(item,index) in topicList" :key="index" >
        <!-- <img @click="toInfo(item.activityId)" src="@/assets/picture/1.png" alt=""> -->
        <img
          @click="toTopicDetail(item.activityId)"
          :src="item.activityPicture" alt="">
        <div class="recommend_shop">
           <ul>
            <!-- <li> -->
            <li
              v-for="(item,index) in item.recommendedTopicsCommodityResponses"
              @click="toInfo(item.commodityId)"
              :key="index">
              <!-- <img src="@/assets/picture/2.png" alt=""> -->
              <img :src="item.firstPicture" alt="">
              <!-- <p>GUCCI</p> -->
              <p>{{item.brandName}}</p>
              <!-- <p>￥950</p> -->
              <p>￥{{item.price}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="like" v-if="recomendList.length > 0 ">
      <div class="like_tit">
        <p>猜你喜欢</p>
        <p>GUESS YOU LIKE</p>
      </div>
      <div class="like_content">
        <good-grid :list.sync="recomendList"></good-grid>
        <van-divider :style="{ color: '#ccc', borderColor: '#ccc', padding: '0 90px' }">已经到底了</van-divider>
      </div>
    </div>
    <TabBar />
  </section>
</template>
<script>
import Download from '@/components/common/Download'
import GoodGrid from '@/components/business/GoodGrid'
import TabBar from '@/components/common/TabBar'
import { getGuessLikeList } from '@/api/good'
import { getHomeTopics, getBigBrand, getRecommend } from '@/api/shop'
import wxapi from '@/utils/wxApi'
export default {
  name: 'index',
  components: { Download, GoodGrid, TabBar },
  data () {
    return {
      step: true,
      extension: false,
      barActive: 'home',
      num: 0,
      images: [
        {
          image: require('@/assets/picture/banner1.jpg')
        },
        {
          image: require('@/assets/picture/banner2.jpg')
        },
        {
          image: require('@/assets/picture/banner3.jpg')
        }
      ],
      icon: {
        normal: require('@/assets/picture/1.png'),
        active: require('@/assets/picture/1.1.png')
      },
      stepList: [
        {
          image: require('@/assets/picture/3.1.png'),
          text: '胖虎自营'
        },
        {
          image: require('@/assets/picture/3.2.png'),
          text: '权威鉴定'
        },
        {
          image: require('@/assets/picture/3.3.png'),
          text: '极速回收'
        },
        {
          image: require('@/assets/picture/3.4.png'),
          text: '招商加盟'
        }
      ],
      newList: [],
      leakList: [],
      zoneList: [],
      brandList: [],
      topicList: [],
      Recommend: [],
      recomendList: [],
      appraiser_url: process.env.VUE_APP_APPRASISER_URL,
      recover_url: process.env.VUE_APP_RECYCLE_URL
    }
  },
  created () {
    let extension = this.$route.query.extension
    if (extension === 1) {
      this.step = false
      this.extension = true
    }
  },
  computed: {
    token () {
      return this.$store.getters.token
    }
  },
  mounted () {
    this.getGuessLikeListData()
    this.getdata()
    wxapi.wxRegister(this.wxRegCallback)
  },
  methods: {
    getdata () {
      getHomeTopics().then(res => {
        this.newList = res.commodityNewActivity
        this.leakList = res.pLeakDetectionActivity
        this.zoneList = res.newZone
      }).catch(err => {
        console.log(err)
      })
      getBigBrand().then(res => {
        this.brandList = res
      }).catch(err => {
        console.log(err)
      })
      getRecommend().then(res => {
        this.topicList = res
      }).catch(err => {
        console.log(err)
      })
    },
    toTopicDetail (id) {
      this.$router.push({ name: 'topicDetail', params: { id: id } })
    },
    goto (i) {
      if (i === 0) {
        this.$router.push({ name: 'selfrun' })
      } else if (i === 1) {
        location.href = 'https://m.ponhu.cn/User/about?os=2'
      } else if (i === 2) {
        location.href = 'http://m.ponhu.cn/Drainage/business'
      }
    },
    service () {
      location.href = 'http://wap.ponhu.cn/miniapi/active/promise.html'
    },
    selfrun () {
      this.$router.push({ name: 'selfrun' })
    },
    recovery () {
      if (this.token) {
        location.href = this.recover_url + 'index?td_channelid=H5'
      } else {
        this.$router.push({ path: '/login?return_url=' + window.location.href })
      }
    },
    step_change (i) {
      if (i === 0) {
        this.$router.push({ name: 'selfrun' })
      } else if (i === 1) {
        location.href = this.appraiser_url
      } else if (i === 2) {
        if (this.token) {
          location.href = this.recover_url + 'index?td_channelid=H5'
        } else {
          this.$router.push({ path: '/login?return_url=' + window.location.href })
        }
      } else if (i === 3) {
        location.href = 'http://m.ponhu.cn/Drainage/business'
      }
    },
    toInfo (id) {
      this.$router.push({ name: 'shopGoodsDetail', params: { gid: id } })
    },
    getGuessLikeListData () {
      getGuessLikeList({ userToken: this.token }).then(res => {
        this.recomendList = res
      }).catch(err => {
        this.$toast(err)
      })
    },
    // 微信注册
    wxRegCallback () {
      // 微信分享
      this.wxShareTimeline()
      this.wxShareAppMessage()
    },
    wxShareTimeline () {
      let _this = this
      let option = {
        title: '胖虎商城',
        link: process.env.VUE_APP_ROOT_URL + 'index.html#/',
        imgUrl: 'https://res.ponhu.cn/new/logo200_200.jpg',
        success: () => {
          _this.$toast('分享成功')
        },
        error: () => {
          _this.$toast('已取消分享')
        }
      }
      // 将配置注入通用方法
      wxapi.ShareTimeline(option)
    },
    wxShareAppMessage () {
      let _this = this
      let option = {
        title: '胖虎商城',
        desc: '闲置奢侈品寄售+养护+鉴定+回收一站式服务平台',
        link: process.env.VUE_APP_ROOT_URL + 'index.html#/',
        imgUrl: 'https://res.ponhu.cn/new/logo200_200.jpg',
        success: () => {
          _this.$toast('分享成功')
        },
        error: () => {
          _this.$toast('已取消分享')
        }
      }
      // 将配置注入通用方法
      wxapi.ShareAppMessage(option)
    }
  }
}
</script>
<style lang="less">
.shop-content{
  width: 100%;
  padding-bottom: 2rem;
   ::-webkit-scrollbar{
    display: none;
  }
  .banner{
    width: 100%;
    height: 450px;
    img{
      width : 100%;
      height: 100%;
    }
    .swiper-pagination-bullet{
      width: 16px;
      height: 16px;
      margin-left: 16px;
    }
    .swiper-pagination-bullet-active{
      background: white;
    }
  }
}

.tab-left:before{
  content: "";
  width: 1px;
  height: 30px;
  background:rgba(229,229,229,1);
  position: absolute;
  right: 50%;
}
.step{
  width: 100%;
  height: 212px;
  background: white;
  .tu{
    width: 25%;
    height: 100%;
    float: left;
    img{
      width: 80px;
      height: 80px;
      display: block;
      margin: 48px auto;
    }
    p{
      font-size:24px;
      font-weight:400;
      color:rgba(40,40,40,1);
      line-height:24px;
      margin-top: -30px;
      text-align: center;
    }
  }
}
.extension{
  width: 100%;
  height: 2rem;
  img{
    float: left;
    height: 2rem;
  }
  img:nth-child(1){
    width: 52%;
  }
  img:nth-child(2){
    width: 48%;
  }
}
.new{
  width: 100%;
  height: 417px;
  background: white;
  .new-cen{
    position: relative;
    width: 702px;
    height: 370px;
    margin: auto;
    img{
      display: block;
      float: left;
      width: 343px;
      margin-left: 16px;
      margin-top: 24px;
    }
    img:nth-child(1){
      width: 343px;
      height: 360px;
      margin-left: 0px;
    }
    img:nth-child(5){
      margin-top: .16rem;
    }
    .new_shop{
      width: 124px;
      height: 34px;
      line-height: 36px;
      background: url(../assets/picture/5.11.png);
      background-size: 100%;
      position: absolute;
      top: 14%;
      left: 21%;
      font-size: 28px;
      color: white;
      padding-left: 30px;
    }
    .leak_shop{
      position: absolute;
      top: 23%;
      left: 54.3%;
      font-size: 28px;
    }
    .zone_shop{
      position: absolute;
      top: 79%;
      left: 54%;
      font-size: 28px;
    }
  }
}
.brand{
  width: 100%;
  background: white;
  margin-top: 25px;
  .tit{
    width: 96%;
    height: 128px;
    padding-left: 24px;
    font-size:36px;
    font-weight:500;
    color:rgba(40,40,40,1);
    span{
      font-size:20px;
      color:rgba(40,40,40,1);
      line-height:128px;
      letter-spacing:4px;
      padding-left: 15px;
    }
  }
  .brand-shop{
    width: 702px;
    height: 684px;
    margin: auto;
    img{
      width: 228px;
      height: 320px;
      float: left;
    }
    img:nth-child(n+4){
      margin-top: 9px;
    }
    img:not(:nth-child(3n)){
      margin-right: 9px;
    }
  }
  .recommend{
    width: 100%;
    img{
      width: 100%;
      height: 450px;
    }
    .recommend_shop{
      width: 100%;
      height: 340px;
      overflow-x: scroll;
      ul{
        width: max-content;
        height: 340px;
        li{
          cursor: pointer;
          width: 149px;
          height: 340px;
          height: 100%;
          float: left;
          margin-left: 50px;
          img{
            width: 149px;
            height: 149px;
            margin-top: 35%;
          }
          p{
            text-align: center;
            line-height: 20px;
          }
          p:nth-child(2){
            width: 100%;
            color: rgb(153,153,153);
            font-size: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 70px;
          }
          p:nth-child(3){
            color: #DA3232;
            font-size: 20px;
            margin-top: -25px;
            font-weight: bold;
          }
        }
      }
    }
  }
}
.like{
  width: 100%;
  .like_tit{
    width: 100%;
    height: 100px;
    p{
      text-align: center;
    }
    p:nth-child(1){
      font-size: 36px;
      font-weight: 600;
    }
     p:nth-child(2){
      font-size: 20px;
      margin-top: -4%;
    }
  }
  .like_content{
    padding: 0 24px;
  }
}
</style>
